// extracted by mini-css-extract-plugin
export default {"badge":"badge---YZ61j","label":"label---GJyim","default":"default---qdfFn","red":"red---we77s","primary":"primary---VDD8Y","small":"small---Xcvd7","medium":"medium---XiEJC"};